import * as React from 'react'

import { classNames } from 'src/utils/classNames'

import { PiInfo } from 'react-icons/pi'

import Popover from './Popover'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string
  info?: string
  rightIcon?: React.ReactNode
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, label, info, rightIcon, ...props }, ref) => {
  const inputId = props.id ?? props.name ?? label

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={inputId} className="ml-2 flex gap-1 text-th-text-secondary">
          {label}
          {props.required && !props.disabled && (
            <div aria-hidden="true" className="text-th-error">
              *
            </div>
          )}
          {info && (
            <Popover text={info} position="bottom">
              <button type="button" aria-label={`${label} information`} className="mb-auto h-4 w-4 border-none bg-transparent p-0 text-2xl text-gray-500">
                <PiInfo aria-hidden="true" />
              </button>
            </Popover>
          )}
        </label>
      )}
      <div className="relative">
        <input
          name={props.name ?? label}
          id={inputId}
          type={type}
          className={classNames(
            'w-full rounded-full border border-th-border bg-th-content px-4 py-2 font-body text-sm text-th-text placeholder-gray-300 placeholder:font-light disabled:pointer-events-none disabled:opacity-50',
            rightIcon ? 'pr-10' : '',
            className
          )}
          ref={ref}
          disabled={props.disabled}
          {...props}
        />
        {rightIcon && <div className="absolute right-2 top-1/2 h-5 -translate-y-1/2">{rightIcon}</div>}
      </div>
    </div>
  )
})

Input.displayName = 'Input'

export default Input
